import { InputCostumeErrorType, InputErrorType } from "types/form-types";

export const numberOrUndefined = (value: string | undefined | null | number): number | undefined => {
    if (value === undefined || value === null || value === '') return undefined;
    return Number(value);
}

export function getInputErrors(validity: ValidityState) {
    let errors: InputErrorType[] = [];
    if (validity.badInput) {
        errors.push({
            name: 'badInput',
            message: 'form.errors.badInput'
        })
    }
    if (validity.customError) {
        errors.push({
            name: 'customError',
            message: 'form.errors.customError'
        })
    }
    if (validity.patternMismatch) {
        errors.push({
            name: 'patternMismatch',
            message: 'form.errors.patternMismatch'
        })
    }
    if (validity.rangeOverflow) {
        errors.push({
            name: 'rangeOverflow',
            message: 'form.errors.rangeOverflow'
        })
    }
    if (validity.rangeUnderflow) {
        errors.push({
            name: 'rangeUnderflow',
            message: 'form.errors.rangeUnderflow'
        })
    }
    if (validity.stepMismatch) {
        errors.push({
            name: 'stepMismatch',
            message: 'form.errors.stepMismatch'
        })
    }
    if (validity.tooLong) {
        errors.push({
            name: 'tooLong',
            message: 'form.errors.tooLong'
        })
    }
    if (validity.tooShort) {
        errors.push({
            name: 'tooShort',
            message: 'form.errors.tooShort'
        })
    }
    if (validity.typeMismatch) {
        errors.push({
            name: 'typeMismatch',
            message: 'form.errors.typeMismatch'
        })
    }
    if (validity.valid) {
        errors.push({
            name: 'valid',
            message: 'form.errors.valid'
        })
    }
    if (validity.valueMissing) {
        errors.push({
            name: 'valueMissing',
            message: 'form.errors.valueMissing'
        })
    }

    return errors;
}

type AppInputElement = {
    setCustomValidity: (s: string) => void,
    checkValidity: () => boolean,
    validity: ValidityState
};

export const validateInput = <T, TInputElement extends AppInputElement>(props: {
    value: T | undefined | null
    input?: TInputElement, 
    inputWrapper?: HTMLDivElement
    customErrors?: InputCostumeErrorType<T, TInputElement>[],
    soft: boolean
}) => {
    if(!props.input || !props.inputWrapper) return;
    let errors:InputErrorType[] = [];
    if (props.customErrors?.length) {
        for (let index = 0; index < props.customErrors.length; index++) {
            const customError = props.customErrors[index];
            if (!customError.validate(props.value, props.input)) {
                errors.push({
                    message: customError.message,
                    name: customError.name
                });
                break;
            }
        }
    }

    props.input.setCustomValidity(errors.length ? errors[0].name : '');

    
    if (props.input.checkValidity() || props.soft) {
        props.inputWrapper.classList.remove('error');
    } else {
        props.inputWrapper.classList.add('error');
        if(props.input && !errors.length) errors = getInputErrors(props.input.validity);
    }

    return props.soft ? [] : errors;
}
